import { render, staticRenderFns } from "./MarkData.vue?vue&type=template&id=1c0c0c0e&scoped=true"
import script from "./MarkData.vue?vue&type=script&lang=js"
export * from "./MarkData.vue?vue&type=script&lang=js"
import style0 from "./MarkData.vue?vue&type=style&index=0&id=1c0c0c0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c0c0e",
  null
  
)

export default component.exports